import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'
import MainLayout from './components/admin/layout/MainLayout.vue'
import AuthFormLayout from './components/admin/layout/AuthFormLayout.vue'
import store from './store'

// Pages
import AdminIndexPage from './pages/admin/AdminIndexPage.vue'
import LoginPage from './pages/auth/LoginPage.vue'
import CompBasicInfo from './pages/admin/basic-info/CompBasicInfo.vue'
import CompContract from './pages/admin/basic-info/CompContract.vue'
import EmpBasicInfo from './pages/admin/basic-info/EmpBasicInfo.vue'
import EmpContract from './pages/admin/basic-info/EmpContract.vue'
import WageBasic from './pages/admin/wage/WageBasic.vue'
import WageLedger from './pages/admin/wage/WageLedger.vue'
import WageCompare from './pages/admin/wage/WageCompare.vue'
import CmsTest from './pages/cms/CmsTest.vue'
import CmsList from './pages/cms/CmsList.vue'
import WageExcelUp from './pages/admin/wage/WageExcelUp.vue'
const routes: readonly RouteRecordRaw[] = [
  {
    path: '/',
    redirect: '/LoginPage',
  },
  { 
    path: '/LoginPage',
    component: LoginPage,
    name: 'LoginPage',
    meta: { layout: AuthFormLayout }
  },
  { 
    path: '/AdminIndexPage',
    component: AdminIndexPage,
    name: 'AdminIndexPage',
    meta: { layout: MainLayout, requiresAuth: true }
  },
  { 
    path: '/CompBasicInfo',
    component: CompBasicInfo,
    name: 'CompBasicInfo',
    meta: { layout: MainLayout, requiresAuth: true }
  },
  { 
    path: '/CompContract',
    component: CompContract,
    name: 'CompContract',
    meta: { layout: MainLayout, requiresAuth: true }
  },
  { 
    path: '/EmpBasicInfo',
    component: EmpBasicInfo,
    name: 'EmpBasicInfo',
    meta: { layout: MainLayout, requiresAuth: true }
  },
  { 
    path: '/EmpContract',
    component: EmpContract,
    name: 'EmpContract',
    meta: { layout: MainLayout, requiresAuth: true }
  },
  { 
    path: '/WageBasic',
    component: WageBasic,
    name: 'WageBasic',
    meta: { layout: MainLayout, requiresAuth: true }
  },
  { 
    path: '/WageLedger',
    component: WageLedger,
    name: 'WageLedger',
    meta: { layout: MainLayout, requiresAuth: true }
  },
  { 
    path: '/WageCompare',
    component: WageCompare,
    name: 'WageCompare',
    meta: { layout: MainLayout, requiresAuth: true }
  },
  { 
    path: '/CmsTest',
    component: CmsTest,
    name: 'CmsTest',
    meta: { layout: MainLayout, requiresAuth: true }
  },
  { 
    path: '/WageExcelUp',
    component: WageExcelUp,
    name: 'WageExcelUp',
    meta: { layout: MainLayout, requiresAuth: true }
  },
  { 
    path: '/CmsList',
    component: CmsList,
    name: 'CmsList',
    meta: { layout: MainLayout, requiresAuth: true }
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  const isLoggedIn = store.getters.isLoggedIn;
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

  if (requiresAuth && !isLoggedIn) {
    // 로그인이 필요한 페이지에 접근 시도하고 로그인되지 않은 경우
    next('/LoginPage');
  } else if (to.name === 'LoginPage' && isLoggedIn) {
    // 이미 로그인된 상태에서 로그인 페이지에 접근 시도하는 경우
    next('/AdminIndexPage');
  } else {
    next();
  }
});

export default router